import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import EnhancedSearchOptionsContent from './EnhancedSearchOptionsContent';
import SearchBubbles from './SearchBubbles';
const SearchOptions = ({ searchOptions, showSearchEnhancements = false }) => {
    if (!showSearchEnhancements) {
        return (_jsx("div", { className: "mt-3 flex flex-wrap gap-2", onMouseDown: (event) => event.preventDefault(), children: _jsx(SearchBubbles, { searchOptions: searchOptions }) }));
    }
    return _jsx(EnhancedSearchOptionsContent, { searchOptions: searchOptions, className: "mt-2" });
};
export default observer(SearchOptions);
